import ReactGA from 'react-ga4'

export const initGA = (trackingID: string) => {
  ReactGA.initialize(trackingID)
}

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path })
}

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  })
}